import React from 'react'

import { useBusinessCard } from 'components/BusinessCard/context'
import IdBadge from 'Profiles/IdBadge'

const IdBadgeContainer = () => {
  const { cardMeta: { showOnlyFields }, resource } = useBusinessCard()

  if (!showOnlyFields.includes('id')) return null

  return (
    <IdBadge id={resource.id} />
  )
}

export default IdBadgeContainer
